/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, OnInit, ViewChild, ViewContainerRef, EventEmitter, Input, ViewRef, Output } from '@angular/core';
import { CommonService } from '../../../services/common.service';

@Component({
    selector: 'dynamic-wrapper',
    templateUrl: './dynamic-wrapper.component.html',
    styleUrls: ['./dynamic-wrapper.component.scss'],
    standalone: false
})
export class DynamicWrapperComponent implements OnInit {

  @Input() viewRef: ViewRef;
  @Input() parentViewRef: ViewContainerRef;
  @Input() parentComponents: any;
  @Input() viewOnly: boolean;

  @Output() remove = new EventEmitter<any>();

  @Input() staticParameters: any;
  @Input() dynamicParameters: any;

  @Input() moduleName: string;
  @Input() componentName: string;
  @Input() displayName: string;

  @Input() positionId: string;

  @ViewChild('dynamicComponent', { read: ViewContainerRef, static: false }) wrapperViewContainerRef: ViewContainerRef;

  constructor(private commonService: CommonService) {

  }

  ngOnInit() {
    if (this.viewRef || !this.viewOnly) {
      return;
    }
    var self = this;
    this.commonService.createDynamicComponent(this.moduleName, this.componentName, this.wrapperViewContainerRef, function (err, containerRef) {
      if (self.staticParameters) {
        (<any>containerRef.instance).staticParameters = self.staticParameters;
      }
      if (self.dynamicParameters) {
        (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
      }
      (<any>containerRef.instance).positionId = self.positionId;
    });
  }

  removeElement() {
    if (this.viewOnly) {
      return;
    }
    this.remove.emit({
      viewRef: this.viewRef,
      parentViewRef: this.parentViewRef,
      parentComponents: this.parentComponents
    });
  }

  drag(event) {
    if (this.viewOnly) {
      event.preventDefault();
      return;
    }
    event.dataTransfer.setData("component", this.componentName)
    event.dataTransfer.setData("module", this.moduleName);
    if (this.displayName) {
      event.dataTransfer.setData("displayName", this.displayName);
    }
    if (this.positionId) {
      event.dataTransfer.setData("positionId", this.positionId);
    }
    if (this.staticParameters) {
      event.dataTransfer.setData("staticParameters", JSON.stringify(this.staticParameters));
    }
    if (this.viewRef) {
      // The component is dragged from template
      event.dataTransfer.setData("dynamicComponent", true);
      (<any>window).removeData = {
        viewRef: this.viewRef,
        parentViewRef: this.parentViewRef,
        parentComponents: this.parentComponents
      };
    }
  }
}


